module.exports = __webpack_public_path__ + "img/mainmenbuttonGREEN.905d2a69.png";